export const routeConfig = [
  {
    path: '/',
    name: 'Dashboard',
    icon: 'Dashboard',
  },
  {
    path: '/workers',
    name: 'Workers',
    icon: 'Engineering',
  },
  {
    path: '/accounts',
    name: 'Accounts',
    icon: 'AccountCircle',
  },
  {
    path: '/schedule',
    name: 'Schedule',
    icon: 'Schedule',
  },
  {
    path: '/videos',
    name: 'Media',
    icon: 'VideoLibrary',
  },
  {
    path: '/settings',
    name: 'Settings',
    icon: 'Settings',
  },
];
